// Copyright (c) 2019 Comsearch, Inc., All rights reserved

const isWithinMinMaxVals = (v, min, max) => (
  parseFloat(v) >= min && parseFloat(v) <= max
)

export default isWithinMinMaxVals
